import React from 'react';
import { useInView } from '../hooks/useInView';
export function MechanismReveal() {
  const {
    ref: ref1,
    isVisible: vis1
  } = useInView();
  const {
    ref: ref2,
    isVisible: vis2
  } = useInView();
  return <section className="py-24 px-4 bg-[#0F0F0F] relative overflow-hidden" data-id="element-118">
      <div className="absolute top-1/2 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-119" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-120" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-121">
        <div ref={ref1} className={`text-center mb-16 ${vis1 ? 'anim-fade-up' : 'anim-hidden'}`} data-id="element-122">
          <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-123">
            Existe un principio que los economistas conductuales descubrieron
            hace décadas, que los ricos aplican sin darse cuenta, y que el 97%
            de los asalariados nunca aprende:
          </p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-10" data-id="element-124">
            El dinero que ves disponible,{' '}
            <span className="text-gold-500 italic" data-id="element-125">lo gastás.</span>
          </h2>
          <div className="text-left max-w-3xl mx-auto space-y-6 text-lg text-gray-300" data-id="element-126">
            <p data-id="element-127">
              No importa cuánto ganes. No importa cuánto quieras ahorrar. Si el
              dinero está ahí, visible, accesible — tu cerebro lo procesa como
              "disponible para gastar". Y lo gasta.
            </p>
            <p data-id="element-128">
              Por eso los presupuestos comunes fallan. Por eso las apps de
              finanzas personales no funcionan. Por eso los consejos de "anota
              cada gasto" te duran tres días.
            </p>
            <p className="text-2xl font-bold text-white text-center py-6" data-id="element-129">
              No es voluntad. Es diseño cerebral.
            </p>
            <p className="text-center" data-id="element-130">
              Y la única forma de ganarle a ese diseño es con un sistema que
              trabaje en sentido contrario.
            </p>
            <p className="text-center text-gray-400 uppercase tracking-widest text-sm font-semibold pt-8" data-id="element-131">
              A eso lo llamamos:
            </p>
          </div>
        </div>

        <div ref={ref2} className={`bg-gradient-to-b from-[#1A1A1A] to-[#0A0A0A] border border-gold-500/30 rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(212,168,83,0.1)] ${vis2 ? 'anim-fade-scale' : 'anim-hidden'}`} data-id="element-132">
          <h3 className="font-serif text-3xl md:text-5xl font-bold text-gold-400 mb-6" data-id="element-133">
            EL SISTEMA DE PRESUPUESTO INVERSO
          </h3>
          <p className="text-xl md:text-2xl text-white font-medium mb-12 max-w-2xl mx-auto" data-id="element-134">
            El método que pone tu futuro financiero PRIMERO — antes de que tu
            cerebro pueda gastar lo que no debe.
          </p>
          <div className="text-left space-y-6 text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-135">
            <p className="font-bold text-white" data-id="element-136">
              La lógica es simple y devastadoramente efectiva:
            </p>
            <p data-id="element-137">En lugar de gastar y después intentar ahorrar lo que sobre…</p>
            <div className="bg-gold-500/10 border border-gold-500/20 rounded-xl p-6 my-8" data-id="element-138">
              <p className="text-2xl font-bold text-gold-400 text-center" data-id="element-139">
                Primero separás. Primero invertís. Primero construís.
              </p>
              <p className="text-center text-white mt-4 font-medium" data-id="element-140">
                Y recién después vivís con lo que queda.
              </p>
            </div>
            <p data-id="element-141">
              Cuando invertís el orden, algo extraordinario sucede:{' '}
              <strong className="text-white" data-id="element-142">
                aprendés a vivir con lo que tenés
              </strong>
              , dejás de depender del "si me sobra", y en 30 días ya tenés más
              control financiero del que tuviste en los últimos 10 años.
            </p>
            <p className="text-center font-semibold text-white pt-4" data-id="element-143">
              No necesitás ganar más. No necesitás privarte de todo. Solo
              necesitás cambiar el orden.
            </p>
          </div>
        </div>
      </div>
    </section>;
}